import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams to get URL parameters
import CourseBanner from "../../components/course-detail/CourseBanner";
import CourseContentBasic from "../../components/course-detail/CourseContentBasic";
import LessonContent from "../../components/course-detail/LessonContent";
import CourseContent from "../../components/course-detail/CourseContent";
import CourseBuyCard from "../../components/course-detail/CourseBuyCard";
import PageHeader from "../../components/PageHeader";

function CourseDetail() {
  const [courseData, setCourseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { courseId } = useParams(); // Get courseId from URL parameters
  const role = sessionStorage.getItem("role");
  useEffect(() => {
    const studentId = sessionStorage.getItem("id");
    // Use courseId from URL parameters instead of hardcoded value
    const token = process.env.REACT_APP_API_TOKEN; 
    const LMS = process.env.REACT_APP_API_LMS;

    // Only proceed if courseId is available
    if (!courseId) {
      setError("Course not found. Please check the URL and try again.");
      setIsLoading(false);
      return;
    }

    const raw = JSON.stringify({
      "user_id": studentId,
      "course_id": courseId,
      "role": role
    });

    fetch(`${LMS}/api/course-module-details`, {
      method: "POST",
      headers: {
        "Authorization": token,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: raw,
    })
      .then(async (response) => {
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("Course not found");
          } else if (response.status === 403) {
            throw new Error("You don't have permission to access this course");
          } else {
            throw new Error("Something went wrong. Please try again later");
          }
        }
        return response.json();
      })
      .then((data) => {
        setCourseData(data);
        setError(null);
      })
      .catch((error) => {
        setError(error.message);
        console.error("Failed to fetch course module details:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [courseId]); // Add courseId as dependency

  return (
    <>
      <div className="row">
        <div className="col-12">
          <PageHeader title="Programs" 
            breadcrumbs={[
              { label: "Dashboard", path: "/dashboard" },
              { label: "Course Details", active: true }
            ]}
          />
        </div>
      </div>

      <div className="row mb-4">
        <CourseBanner data={courseData}/>
      </div>

      <div className="row">
        {isLoading ? (
          <div className="col-12 text-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="col-12 text-center my-5">
            <div className="alert alert-danger" role="alert">
              <i className="ri-error-warning-line me-2"></i>
              {error}
            </div>
          </div>
        ) : courseData ? (
          <>
            <LessonContent data={courseData} />
            <CourseContentBasic data={courseData} />
          </>
        ) : (
          <>
            <CourseContent />
            <CourseBuyCard />
          </>
        )}
      </div>
    </>
  );
}

export default CourseDetail;